/**
 * 카드 메타 줄의 날짜 — `2026. 07. 10` (로케일 무관, Figma 시안 그대로).
 *
 * `toLocaleDateString` 을 쓰지 않는 이유가 둘이다. 하나는 시안이 ko/en 모두 같은
 * 형식이라는 것이고, 다른 하나는 `new Date(iso)` 를 거치면 자정 UTC 값이 실행 환경
 * 시간대에 따라 하루 밀려 서버/클라이언트 렌더가 어긋난다는 것이다. ISO 문자열의
 * 날짜 부분만 잘라 쓰면 둘 다 없다.
 *
 * 에디터픽 캐시의 createdAt 은 스키마상 string 이라 CMS 에 날짜가 없으면 '' 이
 * 박혀 있다 — 그 경우 빈 문자열을 돌려준다.
 */
export const formatCardDate = (iso: string): string => {
  const parts = iso.split('T')[0]?.split('-') ?? [];
  if (parts.length !== 3 || parts.some(part => !part)) return '';

  return parts.join('. ');
};
